import angular from 'angular';
import template from './sign-in.html';
import { HTTP_STATUS_CODES, STATES } from '../../constants';
import { actions, selectors } from '../../state';
import { ERROR, track } from '@updater-core/lib/tracker';

const isCreateSession = actions.session.isCreate;

export default angular
  .module('app.sign-in', [])
  .config(SignInConfig)
  .controller('SigninController', SignInController);

function SignInConfig($stateProvider) {
  $stateProvider.state('app.sign', {
    abstract: true,
    ignore: true,
    params: {
      toast: null,
    },
    views: {
      '@': {
        template,
        controller: 'SigninController as signInCtrl',
      },
    },
    scrollTop: true,
  });

  $stateProvider.state(STATES.SIGN_IN, {
    url: '/sign-in',
    analytics: {
      page: 'Sign In',
    },
    data: {
      permissions: '!signedIn',
    },
  });

  $stateProvider.state(STATES.SIGN_OUT, {
    url: '/sign-out',
    analytics: {
      page: 'Sign Out',
    },
    onEnter: (updStore) => {
      const { dispatch, getState } = updStore;
      const state = getState();

      if (selectors.session.isSignedIn(state)) {
        dispatch(actions.analytics.track('Signed Out'));
        dispatch(
          actions.session.singleton(selectors.session.id(state)).destroy()
        );
      }
    },
  });
}

function SignInController($scope, updStore) {
  const { dispatch, connect } = updStore;

  const disconnect = connect(mapStateToThis)(this);
  $scope.$on('$destroy', disconnect);

  this.signIn = (user) =>
    dispatch(actions.session.create(user)).then(() =>
      dispatch(actions.analytics.track('Signed In'))
    );
}

function mapStateToThis(state) {
  return {
    submitting: selectors.pending.match(isCreateSession, state),
    error: getErrorMessage(state),
  };
}

function getErrorMessage(state) {
  const isLockedOut = selectors.error.accessIsLocked(state);
  if (isLockedOut) {
    track({
      verb: ERROR,
      object: 'locked_out',
    });
  }
  switch (selectors.error.statusCode(isCreateSession, state)) {
    case HTTP_STATUS_CODES.UNAUTHORIZED:
      return isLockedOut
        ? `Uh oh! Looks like you forgot your password. Your account has been locked due to 5 bad login attempts. To reset your password please click "I forgot my password" below.`
        : `Oops! The email or password entered doesn't match our records. Please check them and try again.`;
    case HTTP_STATUS_CODES.REDIRECT:
      // Don't show an error if we are redirecting the user
      return null;
    default:
      return selectors.error.message(isCreateSession)(state);
  }
}
